import styled from 'styled-components';
import Image from '../Image';
export const BackgroundImage = styled(Image) `
  display: block;
  background-size: cover;
  overflow: auto;
  ${({ color }) => (color ? `background-color: ${color};` : '')}
`;
export const Background = styled.section `
  overflow: auto;
  ${({ color }) => (color ? `background: ${color};` : '')}
`;
export const Content = styled.article `
  margin: 0 auto;

  ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.start) && `padding-top: 35px;`};
  ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.before) && `padding-left: 15px;`};
  ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.end) && `padding-bottom: 35px;`};
  ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.after) && `padding-right: 15px;`};
  @supports (padding: max(0px)) {
    ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.start) &&
    `padding-top: max(35px, env(safe-area-inset-top));`};
    ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.before) &&
    `padding-left: max(15px, env(safe-area-inset-left));`};
    ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.end) &&
    `padding-bottom: max(35px, env(safe-area-inset-bottom));`};
    ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.after) &&
    `padding-right: max(15px, env(safe-area-inset-right));`};
  }

  max-width: 100%;
  box-sizing: border-box;
  color: ${({ color }) => color};
  ${({ textAlign }) => textAlign && `text-align: ${textAlign}`};

  @media (min-width: 768px) {
    width: 750px;

    ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.start) && `padding-top: 75px;`};
    ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.before) && `padding-left: 15px;`};
    ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.end) && `padding-bottom: 75px;`};
    ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.after) && `padding-right: 15px;`};

    @supports (padding: max(0px)) {
      ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.start) &&
    `padding-top: max(75px, env(safe-area-inset-top));`};
      ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.before) &&
    `padding-left: max(15px, env(safe-area-inset-left));`};
      ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.end) &&
    `padding-bottom: max(75px, env(safe-area-inset-bottom));`};
      ${({ disablePaddings }) => !(disablePaddings === null || disablePaddings === void 0 ? void 0 : disablePaddings.after) &&
    `padding-right: max(15px, env(safe-area-inset-right));`};
    }
  }

  @media (min-width: 992px) {
    width: 970px;
  }

  @media (min-width: 1200px) {
    width: 1170px;
  }
`;
//# sourceMappingURL=components.js.map